import { useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useSubscriptionValidation } from './useSubscriptionValidation';

export function useNavigationGuard() {
  const router = useRouter();
  const pathname = usePathname() ?? '';
  const { isSubscriptionValid, shouldRedirect, redirectPath, loading } = useSubscriptionValidation();

  useEffect(() => {
    // Don't run guard while loading
    if (loading) return;

    // Don't run guard if subscription is valid
    if (isSubscriptionValid) return;

    // Don't run guard if we shouldn't redirect
    if (!shouldRedirect || !redirectPath) return;

    // Define allowed paths for invalid subscriptions
    const allowedPaths = [
      '/login',
      '/register',
      '/forgot-password',
      '/subscription-expired',
      '/admin/subscription-renewal',
      '/admin/school-subscriptions/create',
      '/admin/subscription-plans',
      '/admin/payments',
      '/admin/course-payments',
      '/admin/coupons',
      '/auth/login',
      '/auth/register',
      '/auth/forgot-password',
      '/auth/reset-password'
    ];

    const isAllowedPath = allowedPaths.some(path => pathname.startsWith(path));

    // If we're not on an allowed path, redirect
    if (!isAllowedPath) {
      // console.log('Navigation guard: Redirecting from', pathname, 'to', redirectPath);
      router.replace(redirectPath);
    }
  }, [pathname, isSubscriptionValid, shouldRedirect, redirectPath, loading, router]);
}

